/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import styled from 'styled-components';
import { Label } from 'nallian-shared-ui/lib/components';

const ModalHeader = styled(({ content, ...rest }) => <Label ribbon content={content} {...rest} />)`
  &.ui.label {
    display: block;
    width: min-content;
    margin: 0 0 1rem;

    :not(:first-child) {
      margin: 2rem 0 1rem;
    }
  }
`;

export default ModalHeader;
